import { axiosAuthInstance } from '@core/axios/axios.authConfig';
import { ParamsGetUserCompanies, ResponseUserCompanies } from '@interface/UserInterface';
import { useQuery, UseQueryOptions } from 'react-query';

export const GetUserCompanies = async ({
  params
}: {
  params: ParamsGetUserCompanies;
}): Promise<APIResponse<ResponseUserCompanies>> => {
  const { data } = await axiosAuthInstance.get(
    // eslint-disable-next-line sonarjs/no-nested-template-literals
    `/me/companies?${params?.name ? `name=${params.name}&` : ''}${
      params?.sort ? `sort=${params.sort}` : ''
    }`
  );
  return data;
};

const useGetUserCompanies = ({
  params,
  options
}: {
  params: ParamsGetUserCompanies;
  options?: UseQueryOptions<APIResponse<ResponseUserCompanies>>;
}) => {
  return useQuery<APIResponse<ResponseUserCompanies>>(
    ['useGetUserCompanies'],
    () => GetUserCompanies({ params }),
    options
  );
};

export default useGetUserCompanies;
